import { useState } from 'react';
import { CaseEventType } from '../types/LegalCase';
import type { ErrorField } from '../types/ErrorField';
import type { AddCaseEventValue } from './useLegalCaseEvents';

// Campos que têm binding próprio na tela; qualquer outro 422 do backend cai no bloco
// residual, para o erro não sumir se o contrato evoluir (mesmo padrão do party form).
const INLINE_FIELDS = new Set(['eventType', 'eventDate', 'text', 'sheetReference']);

export const residualErrors = (errorFields: ErrorField[]): ErrorField[] =>
    errorFields.filter((e) => !INLINE_FIELDS.has(e.fieldName));

interface UseLegalCaseEventFormArgs {
    onSubmit: (value: AddCaseEventValue) => Promise<boolean>;
}

// Estado e handlers do formulário de andamento, fora do componente (diretriz do repo:
// sem função dentro de função). O componente fica só com JSX + bindings. Centraliza o
// reset dos campos ao enviar com sucesso.
export default function useLegalCaseEventForm({ onSubmit }: UseLegalCaseEventFormArgs) {
    const [eventType, setEventType] = useState<CaseEventType>(CaseEventType.OTHER);
    const [eventDate, setEventDate] = useState('');
    const [text, setText] = useState('');
    const [sheetReference, setSheetReference] = useState('');

    const reset = () => {
        setEventType(CaseEventType.OTHER);
        setEventDate('');
        setText('');
        setSheetReference('');
    };

    // Texto é o único campo obrigatório na tela (tipo tem default, data é opcional — o
    // backend assume "hoje" quando ausente).
    const canSubmit = text.trim().length > 0;

    const submit = async () => {
        if (!canSubmit) return;
        const ok = await onSubmit({ eventType, eventDate, text, sheetReference });
        if (ok) reset();
    };

    return {
        eventType, setEventType,
        eventDate, setEventDate,
        text, setText,
        sheetReference, setSheetReference,
        canSubmit, submit, reset,
    };
}
